import { useState, useEffect, useRef } from "react";
import Layout from "./common/App";
import Banner from "./section/Banner";
import About from "./section/About";
import Category from "./section/Category";
import ActiveCandidate from "./section/ActiveCandidate";
import "../../Home.css";

const EmployerHome = () => {
  return (
    <Layout>
      <Banner />
      <About />
      <Category />
      <ActiveCandidate />

      <section className="whyAstrovala bg3 pt-50 pb-50">
        <div className="site-width">
          <div className="whyastroWrap">
            <div className="row col-reverse align-item-center ">
              <div
                className="col-md-5 wow animate__fadeInRight"
                style={{ visibility: "visible", animationName: "fadeInRight" }}
              >
                <div className="imgSec whatisastroImg movenormal">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/other/about-img.png`}
                    alt="img"
                  />
                </div>
              </div>
              <div
                className="col-md-7 wow animate__fadeInLeft"
                style={{ visibility: "visible", animationName: "fadeInLeft" }}
              >
                <div className="halfContent left">
                  <div className="textWrapper light">
                    <h5>Why Employers Choose Us</h5>
                    <h2>
                      Smart, reliable, and flexible staffing — all in one place.
                    </h2>
                    <p>
                      Finding dependable hourly talents shouldn’t be stressful.
                      That’s why businesses trust us to simplify hiring. Whether
                      you run a retail store, restaurant, warehouse, or office —
                      we help you get the right people at the right time,
                      without the overhead or delays.
                    </p>
                    <div className="whychoosePoints mt-4">
                      <div className="whyFeatures mt-3">
                        <div className="whyfeatCard">
                          <img
                            src={`${process.env.PUBLIC_URL}/assets/img/icons/Hiring-Process.svg`}
                            alt="icon"
                          />
                          <h6>Quick & Easy Hiring Process</h6>
                        </div>
                        <div className="whyfeatCard">
                          <img
                            src={`${process.env.PUBLIC_URL}/assets/img/icons/Verified-Candidates.svg`}
                            alt="icon"
                          />
                          <h6>Pre-Verified Candidates</h6>
                        </div>
                        <div className="whyfeatCard">
                          <img
                            src={`${process.env.PUBLIC_URL}/assets/img/icons/Flexible-Workforce.svg`}
                            alt="icon"
                          />
                          <h6>Flexible Workforce</h6>
                        </div>
                        <div className="whyfeatCard">
                          <img
                            src={`${process.env.PUBLIC_URL}/assets/img/icons/Affordable-Transparent.svg`}
                            alt="icon"
                          />
                          <h6>Affordable & Transparent Pricing</h6>
                        </div>
                        <div className="whyfeatCard">
                          <img
                            src={`${process.env.PUBLIC_URL}/assets/img/icons/Real-Time-Updates.svg`}
                            alt="icon"
                          />
                          <h6>Real-Time Updates & Communication</h6>
                        </div>
                        <div className="whyfeatCard">
                          <img
                            src={`${process.env.PUBLIC_URL}/assets/img/icons/Talent.svg`}
                            alt="icon"
                          />
                          <h6>High-Quality Talent Pool</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="appBanner pt-40 pb-50">
        <div className="site-width">
          <div className="appbannerwrapper">
            <div className="row align-item-center">
              <div className="col-md-7">
                <div className="apbnrtitle">
                  <div className="apbnrtitle">
                    <h3>
                     Over 100K employers already hiring smarter with Hourlee.
                    </h3>
                    <p>
                     Join thousands of employers using Hourlee to hire skilled talent in real time.Whether you need extra hands for a few hours, a day, or a short-term project, Hourlee makes hiring fast, flexible, and effortless . Download the app now.
                    </p>
                  </div>
                  <h5>
                    {" "}
                    Get started in seconds — just enter your number and we’ll
                    text you the app link.
                  </h5>
                </div>
                <div className="appbnrinput">
                  <input type="text" placeholder="Enter mobile number..." />
                  <button>Get Link</button>
                </div>
                <div className="aapbnrdownloadbtns">
                  <a href="javascript:void(0)">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/img/other/GplayOneThemeHd.png`}
                      alt="img"
                    />
                  </a>
                  <a href="javascript:void(0)">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/img/other/AppstoreOneThemeHd.png`}
                      alt="img"
                    />
                  </a>
                </div>
              </div>
              <div className="col-md-4 offset-1">
                <div className="appbnrimg">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/other/aapimg-employer.png`}
                    alt="img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default EmployerHome;
